import Welcome from "../../components/Welcome";

const Home = () => <Welcome />;

export default Home;
